import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FirearmAssignablePersonService, FirearmStorageLocationService, RangerFirearmAssignmentLogService, RangerService } from "assets-service";
import { RangerReturnFirearmsToStorageDialogComponent, RangerReturnFirearmsToStorageDialogConfigData, RangerReturnFirearmsToStorageDialogData } from "./ranger-return-firearms-to-storage-dialog.component";



export interface RangerSetToPendingDialogData extends RangerReturnFirearmsToStorageDialogData {
}

export interface RangerSetToPendingDialogConfigData extends RangerReturnFirearmsToStorageDialogConfigData {
}

@Component({
  selector: 'app-ranger-set-to-pending-dialog',
  templateUrl: './ranger-set-to-pending-dialog.component.html',
  styleUrls: ['./ranger-set-to-pending-dialog.component.scss']
})
export class RangerSetToPendingDialogComponent extends RangerReturnFirearmsToStorageDialogComponent {

  constructor(
    dialogRef: MatDialogRef<RangerSetToPendingDialogComponent, RangerSetToPendingDialogData>,
    @Inject(MAT_DIALOG_DATA) data: RangerSetToPendingDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    rangerService: RangerService,
    rangerFirearmAssignmentLogService: RangerFirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, rangerService, rangerFirearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, configService, userStorage);
  }

  isRangerSetToPendingEnabled() {
    return !this.hasPendingActions && !this.form.invalid;
  }

  rangerSetToPending() {
    this.rangerService.rangerSetToPending({
      rangerId: this.data.ranger?.rangerId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item?.comments
    }).subscribe(result => {
      this.item.ranger = result;
      this.dialogRef.close(this.item);
    });
  }

}